export class FriendlyDateGenerator {
    private date: Date | null = null;
    private dateYYYYMMDD: string = '';
    private showRelativeToday: boolean = true;

    constructor(dateYYYYMMDD: string, showRelativeToday: boolean = true) {
        this.showRelativeToday = showRelativeToday;
        this.set(dateYYYYMMDD);
    }

    public set(dateYYYYMMDD: string) {
        this.dateYYYYMMDD = dateYYYYMMDD;
        try {
            this.date = dateYYYYMMDD ? new Date(dateYYYYMMDD) : null;
        } catch (e) {
            console.error('Invalid date format: ' + dateYYYYMMDD + ' date is not set');
        }
    }

    public setShowRelativeToday(showRelativeToday: boolean) {
        this.showRelativeToday = showRelativeToday;
    }

    public getShowRelativeToday(): boolean {
        return this.showRelativeToday;
    }

    public getYYYYMMDD(): string {
        return this.dateYYYYMMDD;
    }

    public isToday(): boolean {
        if (!this.date) {
            return false;
        }
        const today = new Date();
        return this.date.toDateString() === today.toDateString();
    }

    public getDayOfWeek(): string {
        if (!this.date) {
            return '';
        }
        return this.date.toLocaleString('default', { weekday: 'long' });
    }

    public getRelativeTodayText(useShortDateForFarDates: boolean = false): string {
        if (!this.date) {
            return '';
        }
        if (!this.showRelativeToday) {
            return this.getDayAndMonthNumeric();
        }

        const difference = this.getDateDifferenceInDays();
        if (difference === -1) {
            return 'yesterday';
        }
        if (difference < -1) {
            return useShortDateForFarDates ? this.getDayAndMonthNumeric() : '';
        }
        if (difference === 0) {
            return 'today';
        } else if (difference === 1) {
            return 'tomorrow';
        } else if (difference === 2) {
            return 'day after tomorrow';
        } else if (difference >= 3 && difference < 7) {
            return this.getDayOfWeek();
        } else {
            return useShortDateForFarDates ? this.getDayAndMonthNumeric() : '';
        }
    }

    public getDateDifferenceInDays(): number {
        if (!this.date) {
            return 0;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const otherDate = new Date(this.dateYYYYMMDD);
        otherDate.setHours(0, 0, 0, 0);

        const diffInMs = otherDate.getTime() - today.getTime();
        return Math.round(diffInMs / (1000 * 60 * 60 * 24));
    }

    public getDayAndMonth() {
        if (!this.date) {
            return '';
        }
        let date = new Date(this.dateYYYYMMDD);
        return date.toLocaleString('default', { day: 'numeric', month: 'short' });
    }

    public getDayAndMonthNumeric(): string {
        if (!this.date) {
            return '';
        }
        if (this.dateYYYYMMDD) {
            let month: string = this.dateYYYYMMDD.split('-')[2].replace(/^0+/, '');
            let year: string = this.dateYYYYMMDD.split('-')[1];
            return month + '.' + year;
        }
        return '';
    }

    public static getTodayYYYYMMDD(): string {
        return new Date().toISOString().split('T')[0];
    }

    public static getTimeDiffString(date: Date) {
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        if (seconds < 60) {
            return 'w tej chwili';
        } else if (minutes < 120) {
            return `${minutes} minut temu`;
        } else if (hours < 48) {
            return `${hours} godzin temu`;
        } else if (days < 21) {
            return `${days} dni temu`;
        } else if (weeks < 8) {
            return `${weeks} tygodni temu`;
        } else if (months < 36) {
            return `${months} miesięcy temu`;
        } else {
            return `${years} lat temu`;
        }
    }
}
